import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  lazy,
  Suspense,
} from "react";
import FormWizard from "react-form-wizard-component";
// import "react-form-wizard-component/dist/style.css";
// import BidProperty from "@/components/bid/BidProperty";
// import StaticInfo from "@/components/bid/StaticInfo";
// import BidDeposit from "./BidDeposit";
// import AccordianFormProfile from "./DemoAccordian";
import { bidWizardPage, getBidCMS, getBidDepositDetail } from "@/api/bid";
import { useDispatch, useSelector } from "react-redux";
import { setWizardData } from "@/bidFeature/bidwizardSlice";
import { useNavigate } from "react-router";
// import PurchaseCifDetails from "./PurchaseCifDetails";
import {
  BidDepositIcon,
  ContactInfoIcon,
  PlaceBidIcon,
  ProfileIcon,
  UserVerificationIcon,
} from "./WizardIcons";
// import PlaceBid from "./PlaceBid";
import { Container } from "react-bootstrap";
import { ShimmerPostDetails } from "react-shimmer-effects";
import { trackApiCall, trackPageMount } from "@/utils/analytics";
import "./Bid.css";
// Lazy load heavy components
const BidProperty = lazy(() => import("@/components/bid/BidProperty"));
const StaticInfo = lazy(() => import("@/components/bid/StaticInfo"));
const BidDeposit = lazy(() => import("./BidDeposit"));
const AccordianFormProfile = lazy(() => import("./DemoAccordian"));
const PurchaseCifDetails = lazy(() => import("./PurchaseCifDetails"));
const PlaceBid = lazy(() => import("./PlaceBid"));
const FormWizardSample = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [visitedTabs, setVisitedTabs] = useState([0]);
  const [cmsData, setCmsData] = useState(null);
  const [hideDeposit, setHideDeposit] = useState(true);
  const [completedTabs, setCompletedTabs] = useState([]);
  const [propertyData, setPropertyData] = useState(null);

  const [fraudlentSection, setFraudlentSection] = useState(false);
  const [fraudlentAmount, setFraudlentAmount] = useState("");
  // Add these state variables at the top of  component
  const [lastKnownUserId, setLastKnownUserId] = useState(null);
  const [hasInitialized, setHasInitialized] = useState(false);
  const stepBid = useSelector((state) => state?.pdp?.bidCenterData);
  const listing = useSelector(
    (state) => state?.pdp?.pdpInitData?.propertyDetails
  );
  const stepBidUser = useSelector((state) => state?.user?.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const wizardRef = useRef();

  // Memoize callback functions
  const trackGAEvents = useCallback((tabName, cwcotCIFEnabled) => {
    trackApiCall({
      pageName: tabName === "CIF" ? "Render CIF" : `Render ${tabName}`,
      eventCategory: "New-Bid Wizard",
      eventSource: "on tab render",
      eventLabel:
        tabName === "CIF"
          ? `CWCOT CIF Enabled:${cwcotCIFEnabled || false} | SRC :NewBidwizard`
          : "",
    });
  }, []);
  useEffect(() => {
    getBidCMS("pages/bidWizard").then((response) => {
      setCmsData(response?.results?.[0]);
    });
  }, []);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setIsLoading(true);
  //     try {
  //       const payload = {
  //         listingId: stepBid.listingId,
  //         userId: stepBidUser.realbidUserId,
  //         buyerEmail: stepBid.userEmailId,
  //         buyerAmount: 100000,
  //         bidType: stepBid.bidTypes[0],
  //         type: "BID",
  //         newBidFlag: null,
  //       };

  //       const response = await bidWizardPage(payload);

  //       const cwcotValid = propertyData?.cwcotUpdatesValid || false;
  //       const cwcotUpdatesEnabled = propertyData?.cwcotUpdatesEnabled || false;
  //       const isStateWorkFlowEnabled =
  //         response?.data?.validationResult?.preBidCifDetail
  //           ?.isStateWorkflowEnabled || false;
  //       const isStateWorkFlowDurActive =
  //         response?.data?.validationResult?.preBidCifDetail
  //           ?.isStateWorkflowDurationActive || false;

  //       trackApiCall({
  //         pageName: "CWCOT CIF API",
  //         eventCategory: "New-Bid Wizard",
  //         eventSource: "on page mount",
  //         eventLabel: `CWCOTUpdatesEnabled:${cwcotUpdatesEnabled}| CWCOTUpdatesValid:${cwcotValid}`,
  //       });

  //       // Always get bid deposit info regardless of stage
  //       const bidDepositPayload = {
  //         bidAmount: response?.data?.bidRequest?.bidAmount,
  //         bidType: response?.data?.bidRequest?.bidType,
  //         listingId: response?.data?.bidRequest?.listingId,
  //       };

  //       const depositRes = await getBidDepositDetail(bidDepositPayload);
  //       const bidDepositRequired = depositRes?.data?.data?.bidDepositRequired;
  //       setHideDeposit(!bidDepositRequired);

  //       if (
  //         response.status === 200 &&
  //         response?.data?.validationResult?.stage
  //       ) {
  //         dispatch(setWizardData(response.data));
  //         setApiData(response.data);

  //         const stage = response?.data?.validationResult?.stage;

  //         // Set navigation state first, then navigate after a small delay to ensure wizard is ready
  //         const navigateToTab = (targetTab, visited, completed) => {
  //           setCurrentStep(targetTab);
  //           setVisitedTabs(visited);
  //           setCompletedTabs(completed);

  //           targetTab === 2 &&
  //             listing?.address?.state === "CA" &&
  //             trackApiCall({
  //               pageName: "CA State Profile Init",
  //               eventCategory: "New-Bid Wizard",
  //               eventSource: "on tab render",
  //               eventLabel: `stateWorkflowEnabled:${isStateWorkFlowEnabled}| stateWorkflowDurationActive :${isStateWorkFlowDurActive}`,
  //             });

  //           // targetTab === 2 &&
  //           //   listing?.address?.state === "CA" &&
  //           //   trackApiCall({
  //           //     pageName: "Render CWCOT CIF",
  //           //     eventCategory: "New-Bid Wizard",
  //           //     eventSource: "on tab render",
  //           //     eventLabel: `CWCOT CIF Enabled:${isStateWorkFlowEnabled}| SRC :NewBidwizard`,
  //           //   });

  //           // targetTab === 2 &&
  //           //   listing?.commonAttributes?.propCategory === "SC" &&
  //           //   trackApiCall({
  //           //     pageName: "CWCOT Profile Edit",
  //           //     eventCategory: "New-Bid Wizard",
  //           //     eventSource: "on tab render",
  //           //     eventLabel: `stateWorkflowEnabled:${isStateWorkFlowEnabled}| stateWorkflowDurationActive :${isStateWorkFlowDurActive}`,
  //           //   });

  //           // Use setTimeout to ensure wizard is fully rendered before navigation
  //           setTimeout(() => {
  //             wizardRef.current?.goToTab(targetTab);
  //           }, 100);
  //         };

  //         // Handle different stages from API
  //         switch (stage) {
  //           case "USER_PROFILE":
  //           case "PROFILE_COMPLETION": {
  //             trackGAEvents("USER_PROFILE");
  //             // User needs to complete profile - go to first tab
  //             navigateToTab(0, [0], []);
  //             break;
  //           }

  //           case "CIF": {
  //             trackGAEvents("CIF", cwcotUpdatesEnabled);
  //             // User lands on CIF tab
  //             const cifTab = 2;
  //             const cifVisited = Array.from(
  //               { length: cifTab + 1 },
  //               (_, i) => i
  //             );
  //             const cifCompleted = [];
  //             for (let i = 0; i < cifTab; i++) {
  //               cifCompleted.push(i);
  //             }
  //             navigateToTab(cifTab, cifVisited, cifCompleted);
  //             break;
  //           }

  //           case "BID_DEPOSIT": {
  //             trackGAEvents("BID_DEPOSIT");
  //             // User lands on bid deposit tab (if required)
  //             const depositTab = bidDepositRequired ? 3 : 2;
  //             const depositVisited = Array.from(
  //               { length: depositTab + 1 },
  //               (_, i) => i
  //             );
  //             const depositCompleted = [];
  //             for (let i = 0; i < depositTab; i++) {
  //               depositCompleted.push(i);
  //             }
  //             navigateToTab(depositTab, depositVisited, depositCompleted);
  //             break;
  //           }

  //           case "BID_PAGE": {
  //             trackGAEvents("BID_PAGE");
  //             // User can place bid - go to final tab
  //             const bidTab = bidDepositRequired ? 4 : 3;
  //             const bidVisited = Array.from(
  //               { length: bidTab + 1 },
  //               (_, i) => i
  //             );
  //             const bidCompleted = [];
  //             for (let i = 0; i < bidTab; i++) {
  //               bidCompleted.push(i);
  //             }
  //             navigateToTab(bidTab, bidVisited, bidCompleted);
  //             break;
  //           }

  //           case "LOGIN":
  //           case "USER_AUTHORIZATION": {
  //             trackGAEvents("LOGIN");
  //             // User needs to login - redirect or handle accordingly
  //             navigateToTab(0, [0], []);
  //             break;
  //           }

  //           case "ERROR":
  //           default: {
  //             trackGAEvents("ERROR");
  //             // Handle error cases or unknown stages
  //             navigateToTab(0, [0], []);
  //             break;
  //           }
  //         }
  //       } else {
  //         // Fallback if no stage is provided
  //         setCurrentStep(0);
  //         setVisitedTabs([0]);
  //         setCompletedTabs([]);
  //         setTimeout(() => {
  //           wizardRef.current?.goToTab(0);
  //         }, 100);
  //       }
  //     } catch (e) {
  //       console.error(e);
  //       // On error, reset to first tab
  //       setCurrentStep(0);
  //       setVisitedTabs([0]);
  //       setCompletedTabs([]);
  //       setTimeout(() => {
  //         wizardRef.current?.goToTab(0);
  //       }, 100);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   if (stepBid?.listingId && stepBidUser?.realbidUserId) {
  //     fetchData();
  //   } else {
  //     setIsLoading(false);
  //   }
  // }, [stepBid?.listingId, stepBidUser?.realbidUserId, dispatch]);

  // Modified useEffect with smart session handling
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const payload = {
          listingId: stepBid.listingId,
          userId: stepBidUser.realbidUserId,
          buyerEmail: stepBid.userEmailId,
          buyerAmount: 100000,
          bidType: stepBid.bidTypes[0],
          type: "BID",
          newBidFlag: null,
        };

        const response = await bidWizardPage(payload);

        const cwcotValid = propertyData?.cwcotUpdatesValid || false;
        const cwcotUpdatesEnabled = propertyData?.cwcotUpdatesEnabled || false;
        const isStateWorkFlowEnabled =
          response?.data?.validationResult?.preBidCifDetail
            ?.isStateWorkflowEnabled || false;
        const isStateWorkFlowDurActive =
          response?.data?.validationResult?.preBidCifDetail
            ?.isStateWorkflowDurationActive || false;

        trackApiCall({
          eventName: "cwcot_cif_api",
          eventCategory: "New-Bid Wizard",
          eventSource: "on page mount",
          eventLabel: `CWCOTUpdatesEnabled:${cwcotUpdatesEnabled}| CWCOTUpdatesValid:${cwcotValid}`,
        });

        // Always get bid deposit info regardless of stage
        const bidDepositPayload = {
          bidAmount: response?.data?.bidRequest?.bidAmount,
          bidType: response?.data?.bidRequest?.bidType,
          listingId: response?.data?.bidRequest?.listingId,
        };

        const depositRes = await getBidDepositDetail(bidDepositPayload);
        const bidDepositRequired = depositRes?.data?.data?.bidDepositRequired;

        bidDepositRequired &&
          trackApiCall({
            eventName: "bid_deposit_required",
            eventCategory: "New-Bid Wizard",
            eventSource: "on page mount",
          });

        setHideDeposit(!bidDepositRequired);

        if (
          response.status === 200 &&
          response?.data?.validationResult?.stage
        ) {
          dispatch(setWizardData(response.data));
          setApiData(response.data);

          const stage = response?.data?.validationResult?.stage;

          // Set navigation state first, then navigate after a small delay to ensure wizard is ready
          const navigateToTab = (targetTab, visited, completed) => {
            setCurrentStep(targetTab);
            setVisitedTabs(visited);
            setCompletedTabs(completed);

            targetTab === 2 &&
              listing?.address?.state === "CA" &&
              trackApiCall({
                eventName: "ca_state_profile_init",
                eventCategory: "New-Bid Wizard",
                eventSource: "on tab render",
                eventLabel: `stateWorkflowEnabled:${isStateWorkFlowEnabled}| stateWorkflowDurationActive :${isStateWorkFlowDurActive}`,
              });

            // Use setTimeout to ensure wizard is fully rendered before navigation
            setTimeout(() => {
              wizardRef.current?.goToTab(targetTab);
            }, 100);
          };

          // Handle different stages from API
          switch (stage) {
            case "USER_PROFILE":
            case "PROFILE_COMPLETION": {
              trackGAEvents("USER_PROFILE");
              navigateToTab(0, [0], []);
              break;
            }

            case "CIF": {
              trackGAEvents("CIF", cwcotUpdatesEnabled);
              const cifTab = 2;
              const cifVisited = Array.from(
                { length: cifTab + 1 },
                (_, i) => i
              );
              const cifCompleted = [];
              for (let i = 0; i < cifTab; i++) {
                cifCompleted.push(i);
              }
              navigateToTab(cifTab, cifVisited, cifCompleted);
              break;
            }

            case "BID_DEPOSIT": {
              trackGAEvents("BID_DEPOSIT");
              const depositTab = bidDepositRequired ? 3 : 2;
              const depositVisited = Array.from(
                { length: depositTab + 1 },
                (_, i) => i
              );
              const depositCompleted = [];
              for (let i = 0; i < depositTab; i++) {
                depositCompleted.push(i);
              }
              navigateToTab(depositTab, depositVisited, depositCompleted);
              break;
            }

            case "BID_PAGE": {
              trackGAEvents("BID_PAGE");
              const bidTab = bidDepositRequired ? 4 : 3;
              const bidVisited = Array.from(
                { length: bidTab + 1 },
                (_, i) => i
              );
              const bidCompleted = [];
              for (let i = 0; i < bidTab; i++) {
                bidCompleted.push(i);
              }
              navigateToTab(bidTab, bidVisited, bidCompleted);
              break;
            }

            case "LOGIN":
            case "USER_AUTHORIZATION": {
              trackGAEvents("LOGIN");
              navigateToTab(0, [0], []);
              break;
            }

            case "ERROR":
            default: {
              trackGAEvents("ERROR");
              navigateToTab(0, [0], []);
              break;
            }
          }
        } else {
          // Fallback if no stage is provided
          setCurrentStep(0);
          setVisitedTabs([0]);
          setCompletedTabs([]);
          setTimeout(() => {
            wizardRef.current?.goToTab(0);
          }, 100);
        }
      } catch (e) {
        console.error(e);
        // On error, reset to first tab
        setCurrentStep(0);
        setVisitedTabs([0]);
        setCompletedTabs([]);
        setTimeout(() => {
          wizardRef.current?.goToTab(0);
        }, 100);
      } finally {
        setIsLoading(false);
        // Update the last known user ID after successful initialization
        setLastKnownUserId(stepBidUser?.realbidUserId);
        setHasInitialized(true);
      }
    };

    //  session handling logic
    const handleUserSession = () => {
      const currentUserId = stepBidUser?.realbidUserId;
      const listingId = stepBid?.listingId;

      // Check if we have the required data
      if (!listingId || !currentUserId) {
        setIsLoading(false);
        return;
      }

      // First time initialization
      if (!hasInitialized) {
        // console.log("First time initialization - calling API");
        fetchData();
        return;
      }

      // Check if user has changed
      if (lastKnownUserId !== currentUserId) {
        // console.log("User changed - calling API for new user");
        fetchData();
        return;
      }

      // Same user - don't call API, just stop loading
      // console.log("Same user - maintaining current state");
      setIsLoading(false);
    };

    handleUserSession();
  }, [stepBid?.listingId, stepBidUser?.realbidUserId, dispatch]);

  //  Add this useEffect to track user changes separately
  useEffect(() => {
    if (stepBidUser?.realbidUserId && hasInitialized) {
      // console.log("User session detected:", {
      //   current: stepBidUser?.realbidUserId,
      //   previous: lastKnownUserId,
      //   isNewUser: lastKnownUserId !== stepBidUser?.realbidUserId,
      // });
    }
  }, [stepBidUser?.realbidUserId, lastKnownUserId, hasInitialized]);
  const handleStepNavigation = useCallback((targetStep) => {
    if (wizardRef.current) {
      setCurrentStep(targetStep);
      const newVisited = [];
      for (let i = 0; i <= targetStep; i++) {
        newVisited.push(i);
      }
      setVisitedTabs(newVisited);
      wizardRef.current.goToTab(targetStep);
    }
  }, []);

  const getIconWithTick = (index, IconComponent) => {
    return (
      <div style={{ position: "relative", display: "inline-block" }}>
        <IconComponent />
        {completedTabs.includes(index) && <span className="tickStyle">✓</span>}
      </div>
    );
  };

  const handleStepCompletion = useCallback(
    (completedStepIndex, nextStepIndex) => {
      // Mark the current step as completed
      setCompletedTabs((prev) => {
        const newCompleted = [...prev];

        // Always mark the current step as completed
        if (!newCompleted.includes(completedStepIndex)) {
          newCompleted.push(completedStepIndex);
        }

        // SPECIAL CASE: If completing Profile (tab 0) and jumping to CIF (tab 2)
        // automatically mark User Verification (tab 1) as completed
        if (completedStepIndex === 0 && nextStepIndex === 2) {
          if (!newCompleted.includes(1)) {
            newCompleted.push(1);
          }
        }

        return newCompleted;
      });

      // Navigate to the next step
      handleStepNavigation(nextStepIndex);
    },
    [handleStepNavigation]
  );

  const markTabAsCompleted = useCallback((tabIndex) => {
    setCompletedTabs((prev) => {
      const newCompleted = [...prev];
      if (!newCompleted.includes(tabIndex)) {
        newCompleted.push(tabIndex);
      }
      return newCompleted;
    });
  }, []);
  const handleFirstAccordionComplete = useCallback(() => {
    setCompletedTabs((prev) => {
      const newCompleted = [...prev];
      if (!newCompleted.includes(0)) {
        newCompleted.push(0);
      }
      return newCompleted;
    });
  }, []);
  const handleFraudRedirect = useCallback(() => {
    // Show deposit tab if hidden
    setHideDeposit(false);
    setFraudlentSection(true);
    const depositTabIndex = hideDeposit ? 3 : 3;
    handleStepNavigation(depositTabIndex);
  }, [hideDeposit, handleStepNavigation]);

  // const tabs = [
  //   {
  //     title: "Profile Completion",
  //     icon: getIconWithTick(0, ProfileIcon),
  //     content: (
  //       <>
  //         {currentStep !== 0 && (
  //           <h4 className="bid-wizard-title">Welcome to Bid Wizard</h4>
  //         )}
  //         <BidProperty setBidPropertyData={setPropertyData} />
  //         <AccordianFormProfile
  //           onNavigate={(nextStep) => handleStepCompletion(0, nextStep)} // Complete step 0, go to nextStep
  //           onFirstAccordionComplete={handleFirstAccordionComplete}
  //           isOfferPage={false}
  //           cmsData={cmsData}
  //         />
  //       </>
  //     ),
  //   },
  //   {
  //     title: "User Verification",
  //     icon: getIconWithTick(1, UserVerificationIcon),
  //     content: null,
  //   },
  //   {
  //     title: "Contact Information",
  //     icon: getIconWithTick(2, ContactInfoIcon),
  //     content: (
  //       <>
  //         <BidProperty setBidPropertyData={setPropertyData} />
  //         <StaticInfo data={cmsData?.purchase_Profile_Static_Info} />
  //         <PurchaseCifDetails
  //           onNavigate={(nextStep) => handleStepCompletion(2, nextStep)} // Complete step 2, go to nextStep
  //           apiData={apiData}
  //           setApiData={setApiData}
  //         />
  //       </>
  //     ),
  //   },
  //   !hideDeposit && {
  //     title: "Bid Deposit Hold",
  //     icon: getIconWithTick(3, BidDepositIcon),
  //     content: (
  //       <>
  //         <BidProperty setBidPropertyData={setPropertyData} />
  //         <BidDeposit
  //           onNavigate={(nextStep) => handleStepCompletion(3, nextStep)} // Complete step 3, go to nextStep
  //           data={cmsData}
  //           fraudlentSection={fraudlentSection}
  //           fraudlentAmount={fraudlentAmount}
  //           setFraudlentAmount={setFraudlentAmount}
  //         />
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Place Bid",
  //     icon: getIconWithTick(hideDeposit ? 3 : 4, PlaceBidIcon),
  //     content: (
  //       <PlaceBid
  //         onFraudRedirect={handleFraudRedirect}
  //         fraudlentAmount={fraudlentAmount}
  //         setFraudlentAmount={setFraudlentAmount}
  //         onMarkCompleted={() => markTabAsCompleted(hideDeposit ? 3 : 4)}
  //       />
  //     ),
  //   },
  // ].filter(Boolean);
  const tabs = [
    {
      title: "Profile Completion",
      icon: getIconWithTick(0, ProfileIcon),
      content: (
        <Suspense fallback={<ShimmerPostDetails card cta variant="SIMPLE" />}>
          {/* {currentStep !== 0 && (
            <h4 className="bid-wizard-title">Welcome to Bid Wizard</h4>
          )} */}
          <BidProperty setBidPropertyData={setPropertyData} />
          <AccordianFormProfile
            onNavigate={(nextStep) => handleStepCompletion(0, nextStep)}
            onFirstAccordionComplete={handleFirstAccordionComplete}
            isOfferPage={false}
            cmsData={cmsData}
          />
        </Suspense>
      ),
    },
    {
      title: "User Verification",
      icon: getIconWithTick(1, UserVerificationIcon),
      content: null,
    },
    {
      title: "Contact Information",
      icon: getIconWithTick(2, ContactInfoIcon),
      content: (
        <Suspense fallback={<ShimmerPostDetails card cta variant="SIMPLE" />}>
          <BidProperty setBidPropertyData={setPropertyData} />
          <StaticInfo data={cmsData?.purchase_Profile_Static_Info} />
          <PurchaseCifDetails
            onNavigate={(nextStep) => handleStepCompletion(2, nextStep)}
            apiData={apiData}
            setApiData={setApiData}
          />
        </Suspense>
      ),
    },
    !hideDeposit && {
      title: "Bid Deposit Hold",
      icon: getIconWithTick(3, BidDepositIcon),
      content: (
        <Suspense fallback={<ShimmerPostDetails card cta variant="SIMPLE" />}>
          <BidProperty setBidPropertyData={setPropertyData} />
          <BidDeposit
            onNavigate={(nextStep) => handleStepCompletion(3, nextStep)}
            data={cmsData}
            fraudlentSection={fraudlentSection}
            fraudlentAmount={fraudlentAmount}
            setFraudlentAmount={setFraudlentAmount}
          />
        </Suspense>
      ),
    },
    {
      title: "Place Bid",
      icon: getIconWithTick(hideDeposit ? 3 : 4, PlaceBidIcon),
      content: (
        <Suspense fallback={<ShimmerPostDetails card cta variant="SIMPLE" />}>
          <PlaceBid
            onFraudRedirect={handleFraudRedirect}
            fraudlentAmount={fraudlentAmount}
            setFraudlentAmount={setFraudlentAmount}
            onMarkCompleted={() => markTabAsCompleted(hideDeposit ? 3 : 4)}
          />
        </Suspense>
      ),
    },
  ].filter(Boolean);

  const tabChanged = useCallback(
    ({ nextIndex }) => {
      if (nextIndex < 0 || nextIndex >= tabs.length) return false;
      if (!visitedTabs.includes(nextIndex)) {
        const newVisited = [...visitedTabs];
        for (let i = 0; i <= nextIndex; i++) {
          if (!newVisited.includes(i)) newVisited.push(i);
        }
        setVisitedTabs(newVisited);
      }
      setCurrentStep(nextIndex);
      return true;
    },
    [visitedTabs, tabs]
  );

  return (
    // <>
    //   {!isLoading ? (
    //     <Container>
    //       <FormWizard
    //         ref={wizardRef}
    //         shape="circle"
    //         color="#2196f3"
    //         onComplete={() => {}}
    //         onTabChange={tabChanged}
    //         startIndex={currentStep}
    //         key={hideDeposit ? "no-deposit" : "with-deposit"}
    //         style={{
    //           "--wizard-tab-bg": "white",
    //           "--wizard-tab-text": "black",
    //           "--wizard-icon-color": "black",
    //         }}
    //       >
    //         {tabs.map((tab, i) => (
    //           <FormWizard.TabContent
    //             key={i}
    //             title={tab.title}
    //             icon={tab.icon}
    //             style={{ margin: 0, padding: 0 }}
    //           >
    //             {tab.content}
    //           </FormWizard.TabContent>
    //         ))}
    //       </FormWizard>
    //     </Container>
    //   ) : (
    //     <Container>
    //       <ShimmerPostDetails card cta variant="SIMPLE" />
    //       <ShimmerPostDetails card cta variant="EDITOR" />
    //     </Container>
    //   )}
    // </>
    // <>
    //   {!isLoading ? (
    //     <>
    //       <div className="d-none d-lg-block">
    //         <Container>
    //           <FormWizard
    //             ref={wizardRef}
    //             shape="circle"
    //             color="#2196f3"
    //             onComplete={() => {}}
    //             onTabChange={tabChanged}
    //             startIndex={currentStep}
    //             key={hideDeposit ? "no-deposit" : "with-deposit"}
    //             style={{
    //               "--wizard-tab-bg": "white",
    //               "--wizard-tab-text": "black",
    //               "--wizard-icon-color": "black",
    //             }}
    //           >
    //             {tabs.map((tab, i) => (
    //               <FormWizard.TabContent
    //                 key={i}
    //                 title={tab.title}
    //                 icon={tab.icon}
    //                 style={{ margin: 0, padding: 0 }}
    //               >
    //                 {tab.content}
    //               </FormWizard.TabContent>
    //             ))}
    //           </FormWizard>
    //         </Container>
    //       </div>
    //       <div className="d-lg-none">
    //         <FormWizard
    //           ref={wizardRef}
    //           shape="circle"
    //           color="#2196f3"
    //           onComplete={() => {}}
    //           onTabChange={tabChanged}
    //           startIndex={currentStep}
    //           key={hideDeposit ? "no-deposit" : "with-deposit"}
    //           style={{
    //             "--wizard-tab-bg": "white",
    //             "--wizard-tab-text": "black",
    //             "--wizard-icon-color": "black",
    //           }}
    //         >
    //           {tabs.map((tab, i) => (
    //             <FormWizard.TabContent
    //               key={i}
    //               title={tab.title}
    //               icon={tab.icon}
    //               style={{ margin: 0, padding: 0 }}
    //             >
    //               {tab.content}
    //             </FormWizard.TabContent>
    //           ))}
    //         </FormWizard>
    //       </div>
    //     </>
    //   ) : (
    //     <Container>
    //       <ShimmerPostDetails card cta variant="SIMPLE" />
    //       <ShimmerPostDetails card cta variant="EDITOR" />
    //     </Container>
    //   )}
    // </>
    <>
      {!isLoading ? (
        <div className="responsive-wizard-container">
          <FormWizard
            ref={wizardRef}
            shape="circle"
            color="#2196f3"
            onComplete={() => {}}
            onTabChange={tabChanged}
            startIndex={currentStep}
            key={hideDeposit ? "no-deposit" : "with-deposit"}
            style={{
              "--wizard-tab-bg": "white",
              "--wizard-tab-text": "black",
              "--wizard-icon-color": "black",
            }}
          >
            {tabs.map((tab, i) => (
              <FormWizard.TabContent
                key={i}
                title={tab.title}
                icon={tab.icon}
                style={{ margin: 0, padding: 0 }}
              >
                {tab.content}
              </FormWizard.TabContent>
            ))}
          </FormWizard>
        </div>
      ) : (
        <Container>
          <ShimmerPostDetails card cta variant="SIMPLE" />
          <ShimmerPostDetails card cta variant="EDITOR" />
        </Container>
      )}
    </>
  );
};
export default FormWizardSample;
// // Add these state variables at the top of your component
// const [lastKnownUserId, setLastKnownUserId] = useState(null);
// const [hasInitialized, setHasInitialized] = useState(false);

// // Modified useEffect with smart session handling
// useEffect(() => {
//   const fetchData = async () => {
//     setIsLoading(true);
//     try {
//       const payload = {
//         listingId: stepBid.listingId,
//         userId: stepBidUser.realbidUserId,
//         buyerEmail: stepBid.userEmailId,
//         buyerAmount: 100000,
//         bidType: stepBid.bidTypes[0],
//         type: "BID",
//         newBidFlag: null,
//       };

//       const response = await bidWizardPage(payload);

//       const cwcotValid = propertyData?.cwcotUpdatesValid || false;
//       const cwcotUpdatesEnabled = propertyData?.cwcotUpdatesEnabled || false;
//       const isStateWorkFlowEnabled =
//         response?.data?.validationResult?.preBidCifDetail
//           ?.isStateWorkflowEnabled || false;
//       const isStateWorkFlowDurActive =
//         response?.data?.validationResult?.preBidCifDetail
//           ?.isStateWorkflowDurationActive || false;

//       trackApiCall({
//         pageName: "CWCOT CIF API",
//         eventCategory: "New-Bid Wizard",
//         eventSource: "on page mount",
//         eventLabel: `CWCOTUpdatesEnabled:${cwcotUpdatesEnabled}| CWCOTUpdatesValid:${cwcotValid}`,
//       });

//       // Always get bid deposit info regardless of stage
//       const bidDepositPayload = {
//         bidAmount: response?.data?.bidRequest?.bidAmount,
//         bidType: response?.data?.bidRequest?.bidType,
//         listingId: response?.data?.bidRequest?.listingId,
//       };

//       const depositRes = await getBidDepositDetail(bidDepositPayload);
//       const bidDepositRequired = depositRes?.data?.data?.bidDepositRequired;
//       setHideDeposit(!bidDepositRequired);

//       if (
//         response.status === 200 &&
//         response?.data?.validationResult?.stage
//       ) {
//         dispatch(setWizardData(response.data));
//         setApiData(response.data);

//         const stage = response?.data?.validationResult?.stage;

//         // Set navigation state first, then navigate after a small delay to ensure wizard is ready
//         const navigateToTab = (targetTab, visited, completed) => {
//           setCurrentStep(targetTab);
//           setVisitedTabs(visited);
//           setCompletedTabs(completed);

//           targetTab === 2 &&
//             listing?.address?.state === "CA" &&
//             trackApiCall({
//               pageName: "CA State Profile Init",
//               eventCategory: "New-Bid Wizard",
//               eventSource: "on tab render",
//               eventLabel: `stateWorkflowEnabled:${isStateWorkFlowEnabled}| stateWorkflowDurationActive :${isStateWorkFlowDurActive}`,
//             });

//           // Use setTimeout to ensure wizard is fully rendered before navigation
//           setTimeout(() => {
//             wizardRef.current?.goToTab(targetTab);
//           }, 100);
//         };

//         // Handle different stages from API
//         switch (stage) {
//           case "USER_PROFILE":
//           case "PROFILE_COMPLETION": {
//             trackGAEvents("USER_PROFILE");
//             navigateToTab(0, [0], []);
//             break;
//           }

//           case "CIF": {
//             trackGAEvents("CIF", cwcotUpdatesEnabled);
//             const cifTab = 2;
//             const cifVisited = Array.from(
//               { length: cifTab + 1 },
//               (_, i) => i
//             );
//             const cifCompleted = [];
//             for (let i = 0; i < cifTab; i++) {
//               cifCompleted.push(i);
//             }
//             navigateToTab(cifTab, cifVisited, cifCompleted);
//             break;
//           }

//           case "BID_DEPOSIT": {
//             trackGAEvents("BID_DEPOSIT");
//             const depositTab = bidDepositRequired ? 3 : 2;
//             const depositVisited = Array.from(
//               { length: depositTab + 1 },
//               (_, i) => i
//             );
//             const depositCompleted = [];
//             for (let i = 0; i < depositTab; i++) {
//               depositCompleted.push(i);
//             }
//             navigateToTab(depositTab, depositVisited, depositCompleted);
//             break;
//           }

//           case "BID_PAGE": {
//             trackGAEvents("BID_PAGE");
//             const bidTab = bidDepositRequired ? 4 : 3;
//             const bidVisited = Array.from(
//               { length: bidTab + 1 },
//               (_, i) => i
//             );
//             const bidCompleted = [];
//             for (let i = 0; i < bidTab; i++) {
//               bidCompleted.push(i);
//             }
//             navigateToTab(bidTab, bidVisited, bidCompleted);
//             break;
//           }

//           case "LOGIN":
//           case "USER_AUTHORIZATION": {
//             trackGAEvents("LOGIN");
//             navigateToTab(0, [0], []);
//             break;
//           }

//           case "ERROR":
//           default: {
//             trackGAEvents("ERROR");
//             navigateToTab(0, [0], []);
//             break;
//           }
//         }
//       } else {
//         // Fallback if no stage is provided
//         setCurrentStep(0);
//         setVisitedTabs([0]);
//         setCompletedTabs([]);
//         setTimeout(() => {
//           wizardRef.current?.goToTab(0);
//         }, 100);
//       }
//     } catch (e) {
//       console.error(e);
//       // On error, reset to first tab
//       setCurrentStep(0);
//       setVisitedTabs([0]);
//       setCompletedTabs([]);
//       setTimeout(() => {
//         wizardRef.current?.goToTab(0);
//       }, 100);
//     } finally {
//       setIsLoading(false);
//       // Update the last known user ID after successful initialization
//       setLastKnownUserId(stepBidUser?.realbidUserId);
//       setHasInitialized(true);
//     }
//   };

//   // Smart session handling logic
//   const handleUserSession = () => {
//     const currentUserId = stepBidUser?.realbidUserId;
//     const listingId = stepBid?.listingId;

//     // Check if we have the required data
//     if (!listingId || !currentUserId) {
//       setIsLoading(false);
//       return;
//     }

//     // First time initialization
//     if (!hasInitialized) {
//       console.log("First time initialization - calling API");
//       fetchData();
//       return;
//     }

//     // Check if user has changed
//     if (lastKnownUserId !== currentUserId) {
//       console.log("User changed - calling API for new user");
//       fetchData();
//       return;
//     }

//     // Same user - don't call API, just stop loading
//     console.log("Same user - maintaining current state");
//     setIsLoading(false);
//   };

//   handleUserSession();
// }, [stepBid?.listingId, stepBidUser?.realbidUserId, dispatch]);

// // Optional: Add this useEffect if you want to track user changes separately
// useEffect(() => {
//   if (stepBidUser?.realbidUserId && hasInitialized) {
//     console.log("User session detected:", {
//       current: stepBidUser?.realbidUserId,
//       previous: lastKnownUserId,
//       isNewUser: lastKnownUserId !== stepBidUser?.realbidUserId
//     });
//   }
// }, [stepBidUser?.realbidUserId, lastKnownUserId, hasInitialized]);
